import React from "react";
import Axios from "axios";

// Static FAQ copy — there's no backend endpoint for this, so faqData()
// below resolves it directly instead of making an API call.
const FAQ_DATA = [
  {
    title: "What is myFit?",
    text: "myFit is a comprehensive health goals management platform for you and your family. We help you focus on what matters most—your health goals—by providing tools to monitor progress and encourage others.",
  },
  {
    title: "How do I open an account?",
    text: "Simply start with your email address. Setting up your account takes just one step—all you need is access to your email to receive a one-time passcode.",
  },
  {
    title: "How private is my data?",
    text: "We do not share, view, or use your data—especially your health-tracking records. Our priority is to keep your information private and secure.",
  },
  {
    title: "What is Family Connect?",
    text: "In simple terms, Family Connect lets you track basic health activities for your teens or family members, such as appointments or health goals. Family members can choose what information to share with you, ensuring everyone’s privacy and boundaries are respected.",
  },
  {
    title: "Do I own my records?",
    text: "You own your data. If you choose to close your account, all your data will be permanently deleted and cannot be restored.",
  },
];

class SiteService {
  constructor() {
    console.log("Er are here anyway");
  }
  // Blog Data {Get}
  blogData() {
    return this.getBlogEnd();
  }

  // Contact Data{POST}
  contactData(value) {
    return this.postContactEnd(value);
  }

  faqData() {
    // Static copy, no backend endpoint — mimics the { data } shape an
    // Axios response would have so callers don't need to change.
    return Promise.resolve({ data: FAQ_DATA });
  }

  priceData() {
    return this.getAuxEnd("/pricing", null);
  }
  
  //----------------------------------------  -----
  //----------------------------------------  -----
  // Unified call below 
  //----------------------------------------  -----
  //----------------------------------------  -----
  getAuxEnd(uri, reqData) {
    const endPoint = process.env.REACT_APP_AUX_ENDPOINT + uri;
    return Axios.get(endPoint)
      .then((response) => {
        // console.log(response);
        // res = response;
        // console.log("~~~~~~~ Toks2 GET ~~~~~~~~");
        return response;
      })
      .catch((error) => {
        if (error.response) {
          //response status is an error code
          console.log(error.response.status);
        } else if (error.request) {
          //response not received though the request was sent
          console.log(error.request);
        } else {
          //an error occurred when setting up the request
          console.log(error.message);
        }
      });
  }

  getBlogEnd() {
    // myfit-api's own /website/blogdata — proxies + caches the real
    // upstream (MAIN_FORUM_SOURCE) rather than this site calling it
    // directly. See .env's REACT_APP_BLOG_ENDPOINT.
    const endPoint = process.env.REACT_APP_BLOG_ENDPOINT;
    return Axios.get(endPoint)
        .then((response) => {
          // console.log(response);
          // res = response;
          // console.log("~~~~~~~ Toks2 GET ~~~~~~~~");
          return response;
        })
        .catch((error) => {
          if (error.response) {
            //response status is an error code
            console.log(error.response.status);
          } else if (error.request) {
            //response not received though the request was sent
            console.log(error.request);
          } else {
            //an error occurred when setting up the request
            console.log(error.message);
          }
        });
  }
  postContactEnd(reqData) {
    // myfit-api's own /website/contactus — see .env's
    // REACT_APP_CONTACT_ENDPOINT. Unlike getAuxEnd/postAuxEnd (which
    // swallow errors below and resolve `undefined` either way, so a caller
    // can't tell success from failure), this deliberately does NOT catch —
    // a rejected promise here lets Contact/Main.js's own .catch() see the
    // real error (network failure or myfit-api's { error, error_key }
    // validation response) instead of silently treating it as success.
    const endPoint = process.env.REACT_APP_CONTACT_ENDPOINT;
    return Axios.post(endPoint, reqData);
  }

  postAuxEnd(uri, reqData) {
    const endPoint = process.env.REACT_APP_AUX_ENDPOINT + uri;
    return Axios.post(endPoint, reqData)
      .then((response) => {
        console.log(response);
        // res = response
        return response;
      })
      .catch((error) => {
        if (error.response) {
          //response status is an error code
          console.log(error.response.status);
        } else if (error.request) {
          //response not received though the request was sent
          console.log(error.request);
        } else {
          //an error occurred when setting up the request
          console.log(error.message);
        }
      });
  }
}

export default SiteService;
